import { throwIfAborted } from '../abort.js';
import { FundingConnectionError } from '../customer/connection-error.js';
import { readFundingConnection } from '../discovery/connection.js';
import { fundingCustomerId } from '../discovery/discover-checkout.js';
import { FundingProviderError } from '../provider-error.js';
/** Credentials are request-local, never part of purchase binding or persisted progress. */
export async function directPurchaseCredentials(provider, signal) {
    throwIfAborted(signal);
    let customerId = fundingCustomerId(provider);
    if (customerId) {
        if (!provider.getCustomer)
            throw new Error('onramp_purchase_credentials_unavailable');
        const customer = await provider.getCustomer(customerId);
        throwIfAborted(signal);
        if (!customer.ok)
            throw new FundingProviderError(customer.error);
        if (customer.value.data.id !== customerId)
            throw new Error('onramp_customer_mismatch');
    }
    else {
        const connection = await readFundingConnection(provider, signal);
        throwIfAborted(signal);
        if (!connection.ok)
            throw new FundingConnectionError(connection.error);
        if (connection.value.status !== 'active')
            return undefined;
        customerId = connection.value.customer.id;
    }
    const credentials = provider.getCredentials?.();
    if (!credentials)
        throw new Error('onramp_purchase_credentials_unavailable');
    if (!credentials.ok)
        throw new Error('onramp_purchase_credentials_unavailable');
    return { customerId, accessToken: credentials.value.accessToken };
}
export function directPurchaseHeaders(credentials) {
    return credentials
        ? {
            'X-MoonPay-Customer-Id': credentials.customerId,
            'X-MoonPay-Access-Token': credentials.accessToken,
        }
        : {};
}
